import { cn } from "@/lib/utils";
import { headingStyles } from "@/lib/design-system/components";
import { HTMLAttributes } from "react";

interface HeadingProps extends HTMLAttributes<HTMLHeadingElement> {
  level?: "h1" | "h2" | "h3" | "h4" | "h5" | "h6";
}

export const Heading = ({
  level = "h1",
  className,
  children,
  ...props
}: HeadingProps) => {
  const Component = level;
  return (
    <Component
      className={cn(headingStyles({ level }), className)}
      {...props}
    >
      {children}
    </Component>
  );
};